import { render, staticRenderFns } from "./RegisterPageMobileEllipse.vue?vue&type=template&id=6a6e2a52&scoped=true&"
import script from "./RegisterPageMobileEllipse.vue?vue&type=script&lang=js&"
export * from "./RegisterPageMobileEllipse.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPageMobileEllipse.vue?vue&type=style&index=0&id=6a6e2a52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6e2a52",
  null
  
)

export default component.exports